<template>
  <div class="head">
    <ul class="nav-l">
    </ul>
    <div class="title-center"><span>{{ name }}</span></div>
    <ul class="nav-r">
      <li v-for="item in nav" :key="item.index" @click="hanle(item.url)" :class="routepath==item.url?'on':''">{{item.name}}</li>
    </ul>
    <AccountInfo :keepalives="kls?true:false"></AccountInfo>
  </div>
</template>

<script>
import AccountInfo from '../layout/account-info';
export default {
  name: 'LayoutHeader',
  components:{
    AccountInfo
  },
  props: {
    kls:[Boolean,Array,String]
  },
  data () {
    return {
      nav: [
        {
          name: '托盘总览',
          url: '/pallet'
        }, {
          name: '关于久鼎',
          url: '/palletabout'
        }, {
          name: '行业分析',
          url: '/palletanalysis'
        }, {
          name: '托盘商城',
          url: '/palletmall'
        }
      ],
      routepath:'',
      name:'托盘总览'
    }
  },
  mounted () {
    let navl=this.nav;
    this.routepath=this.$route.path
    let getdata=navl[navl.findIndex((item) => item.url === this.routepath)]||{}
    if(Object.keys(getdata).length){
      this.name=getdata.name;
    }else if(this.routepath=='/malldetail'){
      this.routepath='/palletmall'
      this.name='托盘商城'
    }
  },
  methods: {
    hanle(url) {
      this.$router.push(url)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav-l,.nav-r{min-width: 30%}
.title-center{
  font-size: 46px;
  font-family:"fzskjt";
  color: #D2DFFF;
  font-style: italic;
  text-shadow: 3px 2px 7px rgba(0,0,0,0.65);
  line-height: 180%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/pallet/pallet-header.vue